import { ArgumentNullException } from '../../../../utility/exception/argument-null.exception';
import { PrimitiveValueObject } from '../../../../utility/model/primitive-value-object.model';

export class SlackOAuthAccessToken extends PrimitiveValueObject<string> {
  static create(value: string): SlackOAuthAccessToken {
    return new SlackOAuthAccessToken(value);
  }
}
